import IconBar from "../../controls/IconBar";
import StarterInfo from "../../util/StarterInfo";
import ToolIcon from "../../controls/ToolIcon";
import React from "react";
import { useDrop } from "react-dnd";
function ToolButton(props) {
    const { t, counter, item, primary, running, onRun, onMakePrimary, onRemove, onEdit, valid, } = props;
    let imageSrc;
    const starter = item;
    if (!starter) {
        return null;
    }
    try {
        imageSrc = StarterInfo.getIconPath(starter);
    }
    catch (err) {
        return null;
    }
    const remove = React.useCallback(() => {
        onRemove(starter);
    }, [onRemove, starter]);
    const setPrimaryTool = React.useCallback(() => {
        onMakePrimary(starter);
    }, [onMakePrimary, starter]);
    const edit = React.useCallback(() => {
        onEdit(starter);
    }, [onEdit, starter]);
    const run = React.useCallback(() => {
        onRun(starter);
    }, [onRun, starter]);
    const staticElements = [
        {
            title: "Run",
            icon: "launch-simple",
            action: run,
            condition: () => (valid ? true : t("Not configured")),
        },
        {
            title: primary ? "Unset as primary" : "Set as primary",
            icon: "plugin-master",
            action: setPrimaryTool,
            condition: () => primary || valid ? true : t("Not configured"),
        },
        {
            title: "Edit",
            icon: "edit",
            action: edit,
        },
        {
            title: "Remove",
            icon: "remove",
            action: remove,
            condition: () => !starter.isGame,
        },
    ];
    const classes = ["tool-button"];
    if (primary) {
        classes.push("tool-button-primary");
    }
    const [spec, dropRef] = useDrop({
        accept: "TOOL",
        hover: (hoveredOverItem) => {
            if (hoveredOverItem.id !== props.item.id) {
                props.onMoveItem(hoveredOverItem.id, props.item.id);
            }
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: dropRef, className: classes.join(" ") },
            React.createElement("div", { className: "tool-icon-container" },
                React.createElement(ToolIcon, { t: t, item: props.item, imageUrl: imageSrc, imageId: counter, isPrimary: primary, valid: valid, onRun: run })),
            React.createElement("div", { className: "tool-icon-text" },
                React.createElement("div", { className: "tool-icon-name" }, starter.name),
                running ? (React.createElement("div", { className: "tool-icon-running" }, t("Running..."))) : null)),
        React.createElement(IconBar, { id: `tool-starter-${starter.id}`, className: "buttons", group: "tool-starter", instanceId: starter.id, staticElements: staticElements, collapse: true, t: t })));
}
export default ToolButton;
